var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMuscioLibrary = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white",
    stroke: "var(--asset-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7141 22.0903V25C12.4519 25 9 21.4201 9 17C9 12.5799 12.4475 9 16.7067 9V12.0133C14.4133 12.0133 11.9333 14.1892 11.9333 17C11.9333 19.8108 14.3333 22.0903 16.7141 22.0903ZM20.3626 11.0479L20.9583 9.96677C19.8652 9.34905 18.6143 9 17.2859 9V10.2479C18.3999 10.2479 19.4453 10.5382 20.3626 11.0479ZM22.3611 13.9637L21.4 14.52C20.68 13.1067 18.7333 12.0133 17.283 12.0133V10.9738C19.4512 10.9738 21.3425 12.1753 22.3611 13.9637ZM25 17C25 16.3545 24.9255 15.7274 24.7855 15.1252L23.6805 15.7398C23.755 16.1474 23.7937 16.5676 23.7937 17C23.7937 20.7281 20.8809 23.749 17.2859 23.749V25C21.545 25 25 21.4201 25 17ZM23.1563 16.9846C23.1563 16.6325 23.1265 16.2896 23.0699 15.9559L22.0133 16.2533C22.046 16.4943 22.064 16.7383 22.064 16.9884C22.064 19.79 19.6933 22.0933 17.283 22.0933V22.9953C20.5264 22.9953 23.1563 20.305 23.1563 16.9846Z",
    fill: "var(--asset-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMuscioLibrary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/muscioLibrary.c452a6f6.svg";
export { ForwardRef as ReactComponent };